const toggle=document.querySelector('[data-nd-menu-toggle]');
const panel=document.querySelector('[data-nd-mobile-panel]');

function closeNDMenu(){
  if(!toggle||!panel)return;
  panel.classList.remove('is-open');
  document.body.classList.remove('nd-menu-open');
  toggle.setAttribute('aria-expanded','false');
  panel.setAttribute('aria-hidden','true');
}

if(toggle&&panel){
  toggle.addEventListener('click',()=>{
    const open=panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded',String(open));
    panel.setAttribute('aria-hidden',String(!open));
    document.body.classList.toggle('nd-menu-open',open);
  });

  panel.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeNDMenu));

  document.addEventListener('keydown',e=>{
    if(e.key==='Escape')closeNDMenu();
  });

  document.addEventListener('click',e=>{
    if(!panel.classList.contains('is-open'))return;
    if(panel.contains(e.target)||toggle.contains(e.target))return;
    closeNDMenu();
  });
}

document.querySelectorAll('[data-nd-sort]').forEach(s=>s.addEventListener('change',()=>{
  const u=new URL(location.href);
  u.searchParams.set('sort_by',s.value);
  location.href=u.toString();
}));